// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__28Yuv","contentWithAssistance":"Content_contentWithAssistance__3vfy5","selectForm":"Content_selectForm__2PuP2"};